export default __webpack_public_path__ + "static/media/footer-play-store-badge.18d46863.svg";